import { Component } from '@angular/core';
import { SpinnerComponent } from '../spinner/spinner.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-no-common-header-layout',
  templateUrl: './no-common-header-layout.component.html',
  styleUrls: ['./no-common-header-layout.component.scss'],
  imports: [RouterModule, SpinnerComponent],
})
export class NoCommonHeaderLayoutComponent {}
